import React, { lazy, Suspense} from 'react';
import SearchBarBS from '../SearchBar/SearchBarBS';
import SearchBarSS from '../SearchBar/SearchBarSS';
import DashboardTab from '../DashBoard/DashBoardTab';
import AuthSettings from '../Auth/AuthSettings';
import Loader from '../Loader/Loader';
import OtherServiceChannels from '../Modal/OtherService';
import AdsModal from '../Modal/AdsModal';



const ShopAll = lazy(() => import('../DropDown/ShopAll'));
const OnDemand = lazy(() => import('../DropDown/OnDemand'));
const Recommended = lazy(() => import('../DropDown/Recommended'));
const OurLocations = lazy(() => import('../DropDown/Ourlocations'));
const ContactUs = lazy(() => import('../DropDown/ContactUs'));
const ModalMenu = lazy(() => import('../Modal/ModalMenu'));
const Footer = lazy(() => import('../Footer/Footer'));
const ContactPageBody = lazy(() => import('../Contact/ContactPageBody'));

export default (props) => (
  <div className='dashboard'>
    <Suspense fallback={<Loader />}>
      <ModalMenu />
      <OtherServiceChannels />
    </Suspense>
    <SearchBarBS />
    <SearchBarSS />
    <DashboardTab />
    <AuthSettings />
    <AdsModal />
    <Suspense fallback={<Loader />}>
      <ContactPageBody />
    </Suspense>
    <Suspense fallback={<Loader />}>
      <ShopAll />
      <OnDemand />
      <Recommended />
      <OurLocations />
      <ContactUs />
      <Footer />
    </Suspense>
  </div>
);
